<template>
  <div>
    <component :is="isMobile ? MobileLayout : padLayout">
      <template #routerView>
        <RouterView />
      </template>
    </component>
  </div>
</template>
<script setup>
import MobileLayout from './homeLayout_3.0.vue'
import padLayout from './padLayout/index.vue'
import { computed } from 'vue'
import { usePageResizeStore } from '@/store/pageResize'
const pageResizeStore = usePageResizeStore()

const isMobile = computed(() => pageResizeStore.isMobile)
</script>
<style lang="less" scoped></style>
